import { useState } from 'react';
import { useFadeIn, FadeUp } from '../hooks/useFadeIn';

const SQUIRE_BOOKING_URL = 'https://getsquire.com/booking/brands/bro-code-barbershop';
const LocationCard = ({ number, city, address, unit, postalCode, phone, mapSrc }) => {
  const [hovered, setHovered] = useState(false);
  const [ref, visible] = useFadeIn(0.1);
  return (
    <div ref={ref} className={`location-card ${hovered ? 'location-card--hovered' : ''}`}
      style={{
        opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(32px)',
        transition: 'opacity 0.8s cubic-bezier(0.16,1,0.3,1), transform 0.8s cubic-bezier(0.16,1,0.3,1)',
      }}
      onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
    >
      <div className="location-card__header">
        <span className="location-card__num">{number}</span>
        <div className="location-card__header-divider" />
        <h3 className="location-card__city">{city}</h3>
      </div>
      <div className="location-card__map-wrap">
        <div className="location-card__corner location-card__corner--tl" />
        <div className="location-card__corner location-card__corner--tr" />
        <div className="location-card__corner location-card__corner--bl" />
        <div className="location-card__corner location-card__corner--br" />
        <iframe src={mapSrc} className="location-card__map" allowFullScreen="" loading="lazy"
          referrerPolicy="no-referrer-when-downgrade" title={`${city} Location`} />
        <div className="location-card__map-overlay" />
      </div>
      <div className="location-card__info">
        <div className="location-card__address-block">
          <p className="location-card__address-line">{address}{unit ? `, ${unit}` : ''}</p>
          <p className="location-card__address-line">{city}, BC &nbsp;·&nbsp; {postalCode}</p>
        </div>
        <div className="location-card__contact-block">
          <span className="location-card__contact-label">Contact</span>
          <a href={`tel:${phone.replace(/\D/g, '')}`} className="location-card__phone">{phone}</a>
        </div>
      </div>
      <a href={`https://www.google.com/maps/search/${encodeURIComponent(address + ' ' + city + ' BC')}`}
        target="_blank" rel="noopener noreferrer" className="location-card__directions">
        <span>Get Directions</span>
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
          <path d="M1.5 9.5L9.5 1.5M9.5 1.5H3.5M9.5 1.5v6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </a>
    </div>
  );
};

const LocationsSection = ({ onContactClick, locations }) => {
  const [headRef, headVisible] = useFadeIn(0.1);
  return (
    <section id="locations" className="locations">
      <div className="locations__stamp-strip">
        {['TWO LOCATIONS', '///', 'ABBOTSFORD', '///', 'SURREY', '///', 'BC, CANADA'].map((item, i) => (
          <span key={i} className={`locations__stamp${i % 2 === 1 ? ' locations__stamp--gold' : ''}`}>{item}</span>
        ))}
      </div>
      <div ref={headRef} className="locations__header" style={{
        opacity: headVisible ? 1 : 0, transform: headVisible ? 'translateY(0)' : 'translateY(40px)',
        transition: 'opacity 0.9s cubic-bezier(0.16,1,0.3,1), transform 0.9s cubic-bezier(0.16,1,0.3,1)',
      }}>
        <p className="locations__eyebrow">— Find Us</p>
        <h2 className="locations__title">Our <span className="locations__title-gold">Locations.</span></h2>
        <p className="locations__subtitle">Two shops. One standard.<br />Come find us in Abbotsford or Surrey — walk-ins welcome, appointments get priority.</p>
      </div>
      <div className="locations__grid">
        {(locations || []).map((loc, i) => <LocationCard key={loc.id || i} {...loc} />)}
      </div>
      <div className="locations__cta-strip">
        <FadeUp delay={0}><p className="locations__cta-text">Stop waiting.{' '}<span className="locations__cta-gold">Book your seat.</span></p></FadeUp>
       <FadeUp delay={0.12}>
          <a 
  onClick={() => {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-11480037647/YvQ4CIOw3I0cEI_yjeIq'
    });
  }}
  href="https://getsquire.com/booking/brands/bro-code-barbershop" 
  target="_blank" 
  rel="noopener noreferrer" 
  style={{ textDecoration: 'none' }}
>
  <button className="locations__cta-btn">
    Book Your Visit
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </button>
</a>
        </FadeUp>
      </div>
    </section>
  );
};

export default LocationsSection;